import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import accounting from 'accounting'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

dayjs.locale('nl')
accounting.settings = {
	currency: {
		symbol: '€',
		format: '%s %v',
		decimal: ',',
		thousand: '.',
		precision: 2
	},
	number: {
		precision: 0,
		decimal: ',',
		thousand: '.'
	}
};

ReactDOM.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();